// extracted by mini-css-extract-plugin
export var arrow = "slider-module--arrow--JZaox";
export var arrowGroup = "slider-module--arrowGroup--1Qg-J";
export var card = "slider-module--card--Oo2cT";
export var cardHead = "slider-module--cardHead--wRYA4";
export var container = "slider-module--container--lBXfS";
export var description = "slider-module--description--6QSz3";
export var footer = "slider-module--footer--uYgQm";
export var headTitle = "slider-module--headTitle--aoKtj";
export var headWrapper = "slider-module--headWrapper--dCbdP";
export var name = "slider-module--name--Bg-Du";
export var rating = "slider-module--rating--eVxq6";
export var reviewsSwiper = "slider-module--reviewsSwiper--9G6MN";
export var title = "slider-module--title--qxcs6";